module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/cover"
    }
  }, [_vm._v("A WOMAN OF THE IRON PEOPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section6"
    }
  }, [_vm._v("Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section7"
    }
  }, [_vm._v("Anasu")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section8"
    }
  }, [_vm._v("Lixia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section9"
    }
  }, [_vm._v("Enshi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/section10"
    }
  }, [_vm._v("Derek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inahooli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inzara")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tanajin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ulzai")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lixia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eddie")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Angai")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/section21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/1cover"
    }
  }, [_vm._v("WAKING THE MOON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/7chap1#chap1"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/8chap2#chap2"
    }
  }, [_vm._v("PART ONE: DEPARTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/9chap3#chap3"
    }
  }, [_vm._v("1. The Sign")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/10chap4#chap4"
    }
  }, [_vm._v("2. Raising the Naphaïm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/11chap5#chap5"
    }
  }, [_vm._v("3. Oliver and Angelica")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/12chap6#chap6"
    }
  }, [_vm._v("4. The Lunula")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/13chap7#chap7"
    }
  }, [_vm._v("5. The Sound of Bones and Flutes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/14chap8#chap8"
    }
  }, [_vm._v("6. The Reception")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/15chap9#chap9"
    }
  }, [_vm._v("7. Night of the Electric Insects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/16chap10#chap10"
    }
  }, [_vm._v("8. Twilight at the Orphic Lodge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/17chap11#chap11"
    }
  }, [_vm._v("9. The Harrowing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/18chap12#chap12"
    }
  }, [_vm._v("PART TWO: ABSENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/19chap13#chap13"
    }
  }, [_vm._v("i. Pavana Lachrymæ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/20chap14#chap14"
    }
  }, [_vm._v("ii. Threnody: Storm King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/21chap15#chap15"
    }
  }, [_vm._v("iii. Lost Bells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/22chap16#chap16"
    }
  }, [_vm._v("iv. Saranbanda de la Muerta Oscura")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/23chap17#chap17"
    }
  }, [_vm._v("PART THREE: RETURN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/24chap18#chap18"
    }
  }, [_vm._v("10. Ignoreland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/25chap19#chap19"
    }
  }, [_vm._v("11. Ancient Voices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/26chap20#chap20"
    }
  }, [_vm._v("12. The Priestess at Huitica ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/27chap21#chap21"
    }
  }, [_vm._v("13. Other Echoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/28chap22#chap22"
    }
  }, [_vm._v("14. Devil-Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/29chap23#chap23"
    }
  }, [_vm._v("15. Ancient Voices (Echo)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/30chap24#chap24"
    }
  }, [_vm._v("16. Black Angels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/31chap25#chap25"
    }
  }, [_vm._v("17. Falling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/32chap26#chap26"
    }
  }, [_vm._v("18. A Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/33chap27#chap27"
    }
  }, [_vm._v("19. Fire from the Middle Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/34chap28#chap28"
    }
  }, [_vm._v("20. Threnody and Breakdown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/35chap29#chap29"
    }
  }, [_vm._v("21. Waking the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/36chap30#chap30"
    }
  }, [_vm._v("Coda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book2/37chap31#chap31"
    }
  }, [_vm._v("Author's Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LARQUE ON THE WING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d50a351","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 72
// module chunks = 0